module.exports = __webpack_public_path__ + "static/img/9.9e2d596.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/9.png
// module id = e0bq
// module chunks = 0